import React from 'react'

import Paper from 'material-ui/Paper';

import NewUser from '../../../../components/users/NewUser';
import UserList from '../../../../components/users/UserList';

import { users as ROLES_CONFIG } from '../../../../config/roles';

export default class Users extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.newUser.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-5 col-11 ml-3-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <NewUser />
              </Paper> 
            : null
          }
          {
            ROLES_CONFIG.userList.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <UserList />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/users/Users.js